import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
  children: React.ReactNode;
  className?: string;
};
export function Modal(t0) {
  const $ = _c(12);
  const {
    open,
    setOpen,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== setOpen) {
    t1 = () => setOpen(false);
    $[0] = setOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DialogBackdrop className="dialog-backdrop" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== className) {
    t3 = twMerge("relative max-w-(--breakpoint-2xl) rounded-lg bg-white p-3 shadow-inner md:p-6 md:shadow-lg dark:bg-zinc-950", className);
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== t3) {
    t4 = <div className="fixed inset-0 z-20 w-full overflow-y-auto"><div className="flex min-h-full items-center justify-center p-6"><DialogPanel className={t3}>{children}</DialogPanel></div></div>;
    $[5] = children;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== open || $[9] !== t1 || $[10] !== t4) {
    t5 = <Dialog autoFocus={false} open={open} onClose={t1} className="relative z-40">{t2}{t4}</Dialog>;
    $[8] = open;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}